const isImageFile = file => (
  file.type.match('image.*') && ['jpg', 'jpeg', 'png'].includes(file.type.match(/\/([a-z]+)/)[1])
);

export default isImageFile;
